import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { IndicatorRepository } from "@project/data/repositories/technical-proposal/indicator.repository";
import {
    CreateIndicatorComment,
    IndicatorComment,
} from "@project/domain/models/technical-proposals.model";
import { inject, injectable } from "inversify";

@injectable()
export class CreateIndicatorCommentUseCase {
    constructor(
        @inject(IndicatorRepository)
        private readonly indicatorRepository: IndicatorRepository,
    ) {}

    async execute(
        indicatorId: number,
        comment: CreateIndicatorComment,
    ): Promise<Nullable<IndicatorComment>> {
        const commentResult = await this.indicatorRepository.createComment(
            indicatorId,
            comment,
        );

        if (commentResult.isLeft()) {
            ToastManagerStore.error(commentResult.getLeftOrThrow().message);
        }

        return commentResult.fold(
            () => null,
            (createdComment) => createdComment,
        );
    }
}
